/**
 * ToolBoxContainer (#638).
 *
 * Mounts the ToolboxProfileProvider around ToolBox and supplies the tool
 * catalogue (every TOOL_KEY joined to its nav display metadata). Keeping this
 * wiring in a thin container lets ToolBox stay focused on rendering and lets
 * EasyMap mount the customizable toolbox with a single element swap.
 *
 * The catalogue is the FULL set (not permission-filtered) — resolveActiveTools
 * and edit mode apply canDo themselves.
 */

import React, { useMemo } from 'react';
import mapboxgl from 'mapbox-gl';
import ToolBox from './ToolBox';
import { ToolboxProfileProvider } from '../../../context/ToolboxProfileContext';
import { buildToolCatalogue, type CatalogueTool } from './toolboxCatalogue';
import { TOOL_KEYS } from '../../../context/ToolContext';
import { navigationConfig } from '../../../components/navigation/navigationConfig';

interface ToolBoxContainerProps {
  map?: mapboxgl.Map | null;
}

const ToolBoxContainer: React.FC<ToolBoxContainerProps> = ({ map }) => {
  const catalogue = useMemo<CatalogueTool[]>(
    () => buildToolCatalogue(TOOL_KEYS, navigationConfig.main as unknown as Parameters<typeof buildToolCatalogue>[1]),
    [],
  );

  return (
    <ToolboxProfileProvider catalogue={catalogue}>
      <ToolBox map={map} catalogue={catalogue} />
    </ToolboxProfileProvider>
  );
};

export default ToolBoxContainer;
